<template>
  <div class="w-full mb-10 p-4 shadow-md rounded-sm">
    <div class="font-bold mb-5">
      Información de tu tarjeta
    </div>
    <div
      :style="`perspective: 1000px; height: 112px`"
      class="bg-transparent w-48 relative mb-4"
    >
      <div
        :style="`${flip ? 'transform: rotateY(180deg)' : ''}; transition: transform 0.6s; transform-style: preserve-3d`"
        class="relative w-full h-full"
      >
        <div
          style="backface-visibility: hidden"
          class="absolute w-full h-full bg-purple-200 rounded-lg p-3 text-xs shadow mx-auto"
        >
          <div
            class="bg-red-500 w-8 h-3 absolute left-0 top-0 mt-2 ml-3"
          />
          <div
            class="bg-yellow-500 w-5 h-4 absolute left-0 top-0 mt-6 ml-4 rounded"
          />
          <div
            class="bg-yellow-600 w-1 h-4 absolute left-0 top-0 mt-6 ml-6 rounded-sm"
          />
          <div
            v-if="name"
            class="mt-12 font-bold absolute"
          >
            {{ name }}
          </div>
          <div
            v-if="ccn"
            class="mt-8 font-bold absolute"
          >
            {{ ccn.match(/.{1,4}/g).join(" ") }}
          </div>
          <div
            v-if="ccexp"
            class="absolute right-0 bottom-0 pr-16 pb-4"
          >
            {{ ccexp }}
          </div>
          <div
            v-if="ccType && ccType.length === 1"
            class="absolute right-0 bottom-0 pr-1 pb-1"
          >
            <img
              v-if="ccLogo"
              :src="ccLogo"
            >
            <div
              v-else
            >
              {{ ccType[0].niceType }}
            </div>
          </div>
        </div>
        <div
          style="backface-visibility: hidden; transform: rotateY(180deg)"
          class="bg-purple-200 absolute top-0 w-full h-full rounded-lg p-3 pt-8 relative text-xs shadow mx-auto"
        >
          <div
            class="bg-purple-500 w-full h-6 absolute left-0 top-0 mt-3"
          />
          <div
            class="bg-white w-24 h-4 absolute left-0 top-0 ml-1 mt-12"
          />
          <div
            v-if="ccsec"
            class="absolute right-0 bottom-0 mr-24 mb-12 pl-16 pr-1"
          >
            {{ ccsec }}
          </div>
        </div>
      </div>
    </div>
    <div>
      Titular de la tarjeta
    </div>
    <div
      class="bg-purple-100 rounded-md border px-2 py-1 shadow-md text-xl leading-10 h-12 w-full relative"
    >
      <input
        id="name"
        class="bg-transparent"
        type="tel"
        inputmode="numeric"
        pattern="[0-9\s]{13,26}"
        autocomplete="name"
        maxlength="26"
        placeholder="John Doe"
        :value="name"
        @input="name = $event.target.value"
      >
    </div>
    <div>
      Correo electrónico de facturación
    </div>
    <div
      class="bg-purple-100 rounded-md border px-2 py-1 shadow-md text-xl leading-10 h-12 w-full relative mb-5"
    >
      <input
        class="bg-transparent"
        type="email"
        pattern="[0-9\s]{13,26}"
        autocomplete="email"
        maxlength="26"
        :value="email"
        @input="email = $event.target.value"
      >
    </div>
    <div>
      Celular
    </div>
    <div
      class="bg-purple-100 rounded-md border px-2 py-1 shadow-md text-xl leading-10 h-12 w-full relative mb-5"
    >
      <input
        class="bg-transparent"
        type="text"
        autocomplete="phone"
        maxlength="10"
        :value="phoneNumber"
        @input="phoneNumber = $event.target.value"
      >
    </div>
    <div>
      Documento de titular
    </div>
    <div
      class="bg-purple-100 rounded-md border px-2 py-1 shadow-md text-xl leading-10 h-12 w-full relative"
    >
      <input
        id="documentID"
        class="bg-transparent"
        type="tel"
        inputmode="numeric"
        pattern="[0-9\s]{13,19}"
        autocomplete="documentIDr"
        maxlength="19"
        placeholder="71219654"
        :value="documentID"
        @input="documentID = $event.target.value"
      >
    </div>
    <div>
      Número de la tarjeta
    </div>
    <div
      class="bg-purple-100 rounded-md border px-2 py-1 shadow-md text-xl leading-10 h-12 w-full relative"
    >
      <input
        id="cc-number"
        class="bg-transparent"
        type="tel"
        inputmode="numeric"
        pattern="[0-9\s]{13,19}"
        autocomplete="cc-number"
        maxlength="19"
        placeholder="xxxx xxxx xxxx xxxx"
        :value="ccn"
        @input="handleCCN($event)"
      >
    </div>
    <div>
      Fecha de vencimiento
    </div>
    <div
      class="bg-purple-100 rounded-md border px-2 py-1 shadow-md text-xl leading-10 h-12 w-full relative"
    >
      <input
        id="cc-exp"
        class="bg-transparent"
        type="tel"
        inputmode="numeric"
        pattern="[0-9\s]{13,19}"
        autocomplete="cc-exp"
        maxlength="5"
        placeholder="MM/YY"
        :value="ccexp"
        @input="handleCCExp($event)"
      >
    </div>
    <div>
      Código de seguridad
    </div>
    <div
      class="bg-purple-100 rounded-md border px-2 py-1 shadow-md text-xl leading-10 h-12 w-full relative"
    >
      <input
        id="cc-csc"
        class="bg-transparent"
        type="tel"
        inputmode="numeric"
        pattern="[0-9\s]{3}"
        autocomplete="cc-csc"
        maxlength="4"
        placeholder="xxx"
        :value="ccsec"
        @focus="flip = true"
        @blur="flip = false"
        @input="handleCCSec($event)"
      >
    </div>
    <div
      class="flex w-full justify-end"
    >
      <div
        class="cursor-pointer text-red-500 self-center flex leading-8 px-2 py-1 rounded-md mt-5 mr-2"
        @click="$emit('close')"
      >
        <div>
          Cancelar
        </div>
      </div>
      <div
        class="cursor-pointer bg-purple-500 text-white self-center flex leading-8 px-2 py-1 rounded-md mt-5"
        @click="purchase"
      >
        <eva-icon
          class="mt-1 mr-5"
          name="save-outline"
          fill="#FFFFFF"
        />
        <div>
          Guardar
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import creditCardType from 'credit-card-type'
import * as axios from 'axios'

export default {
  name: 'CreditCardForm',
  components: {
  },
  props: {
    planID: { default: '', type: String },
    quantity: { default: 0, type: Number },
  },
  data () {
    return {
      flip: false,
      ccn: '',
      ccexp: '',
      ccsec: '',
      name: '',
      email: '',
      phoneNumber: '',
      documentID: '',
    }
  },
  computed: {
    ccType () {
      return creditCardType(this.ccn)
    },
    ccLogo () {
      try {
        console.info(this.ccType[0].type)
        if (require(`@/assets/${this.ccType[0].type}.svg`)) {
          return require(`@/assets/${this.ccType[0].type}.svg`)
        }
        return null
      } catch (err) {
        return null
      }
    },
    ...mapState({
    }),
  },
  watch: {
  },
  async mounted () {
  },
  methods: {
    async purchase () {
      try {
        this.$f7.preloader.show('Actualizando formulario información...')
        const response = await axios({
          url: '/billing/purchase',
          method: 'POST',
          data: {
            planID: this.planID,
            quantity: this.quantity,
            email: this.email,
            phoneNumber: this.phoneNumber,
            ccn: this.ccn,
            ccexpYear: '20' + this.ccexp.split('/')[1],
            ccexpMonth: this.ccexp.split('/')[0],
            ccsec: this.ccsec,
            name: this.name,
            documentID: this.documentID,
            documentType: 'CC',
          },
        })
        this.$f7.preloader.hide()
        console.info(response)
      } catch (err) {
        this.$f7.preloader.hide()
        console.error(err)
      }
      const planID = this.planID + this.quantity
      console.info(planID)
    },
    handleCCN (e) {
      var txt = e.target.value
      const number = txt.match(/\d/g)
      if (number) {
        this.ccn = number.join('')
      } else {
        this.ccn = ''
      }
    },
    handleCCExp (e) {
      var txt = e.target.value
      const number = txt.match(/\d/g)
      if (number) {
        this.ccexp = number.join('').match(/.{1,2}/g).join('/')
      } else {
        this.ccexp = ''
      }
    },
    handleCCSec (e) {
      var txt = e.target.value
      const number = txt.match(/\d/g)
      if (number) {
        this.ccsec = number.join('')
      } else {
        this.ccsec = ''
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
</style>
